import { useState, useEffect } from 'react';
import { ArrowLeft, RefreshCw, ArrowRight } from 'lucide-react';
import api from '../../utils/api';

const LiveCountTab = ({ onBack, onViewDetails }) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchLiveCount = async () => {
    const fitscan_user = JSON.parse(localStorage.getItem('fitscan_user') || '{}');
    setLoading(true);
    try {
      const response = await api.post('/api/gym/dashboard', {
        identifier: fitscan_user.username,
        expiryDays: 7
      });
      setCount(response.data.livememberCount || 0);
    } catch (error) {
      console.error('Error fetching live count:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLiveCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-8 max-w-4xl mx-auto py-6">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="p-2 bg-[#222] border border-[#2b2b2b] hover:bg-[#2b2b2b] rounded-lg text-gray-400 hover:text-white transition-all"
          >
            <ArrowLeft size={18} />
          </button>
          <div>
            <h1 className="text-2xl font-bold">Live Counter</h1>
            <p className="text-gray-400 text-sm">Real-time gym occupancy monitoring</p>
          </div>
        </div>

        <button
          onClick={fetchLiveCount}
          disabled={loading}
          className="p-2.5 bg-[#222] border border-[#2b2b2b] hover:bg-[#2b2b2b] rounded-lg text-gray-400 hover:text-white disabled:opacity-50"
        >
          <RefreshCw size={18} className={loading ? 'animate-spin' : ''} />
        </button>
      </div>

      {/* Main Counter Graphic */}
      <div className="flex flex-col items-center justify-center bg-gradient-to-b from-[#181818] to-[#121212] border border-[#2b2b2b] rounded-3xl p-12 relative overflow-hidden shadow-2xl">
        {/* Decorative background grid and blurs */}
        <div className="absolute inset-0 bg-[radial-gradient(#84cc16_1px,transparent_1px)] [background-size:16px_16px] opacity-5 pointer-events-none" />
        <div className="absolute -top-24 -left-24 w-48 h-48 rounded-full bg-[#84cc16]/10 blur-[80px] pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-48 h-48 rounded-full bg-blue-500/10 blur-[80px] pointer-events-none" />

        {/* Pulsing ring around counter */}
        <div className="relative w-64 h-64 rounded-full flex items-center justify-center border-4 border-lime-400/20 shadow-[0_0_50px_rgba(132,204,22,0.05)]">
          <div className="absolute inset-2 rounded-full border border-lime-400/40 animate-ping opacity-25" style={{ animationDuration: '3s' }} />

          <div className="text-center z-10">
            <span className="text-7xl font-black text-white tracking-tighter block mb-1">
              {count}
            </span>
            <span className="text-xs uppercase tracking-widest text-[#6CD800] font-bold">
              Checked In
            </span>
          </div>
        </div>

        <div className="mt-8 text-center max-w-sm">
          <h3 className="text-lg font-semibold text-white mb-2">Current Occupancy</h3>
          <p className="text-sm text-gray-400">
            This count represents all members who have checked in via QR scan and have not checked out today.
          </p>
        </div>

        {/* Redirect Button */}
        <button
          onClick={onViewDetails}
          className="mt-8 relative z-10 flex items-center gap-2 bg-lime-400 hover:bg-lime-300 text-zinc-950 px-6 py-3 rounded-xl font-bold transition-all shadow-lg hover:shadow-lime-400/10 group cursor-pointer"
        >
          <span>View Occupant Details</span>
          <ArrowRight size={16} className="transform group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </div>
  );
};

export default LiveCountTab;
